import { __assign, __rest } from "tslib";
import { createAction } from 'redux-actions';
import { actionTypePrefix, SimpleXHREndpoint, SimpleXHRMethod, } from './constants';
export var makeGiveLlamaXHRCall = function (_a) {
    var username = _a.username, onBadgeSent = _a.onBadgeSent;
    var data = {
        foruser: username,
    };
    return makeXHRCall({
        endpoint: SimpleXHREndpoint.GIVE_LLAMA,
        method: SimpleXHRMethod.POST,
        data: data,
        onSuccess: onBadgeSent,
    });
};
export var makeGivePointsXHRCall = function (_a) {
    var username = _a.username, pointsAmount = _a.pointsAmount, message = _a.message, callbacks = __rest(_a, ["username", "pointsAmount", "message"]);
    var data = {
        recipient_username: username,
        amount: pointsAmount,
        message: message || undefined,
    };
    return makeXHRCall(__assign({ endpoint: SimpleXHREndpoint.GIVE_POINTS, method: SimpleXHRMethod.POST, data: data }, callbacks));
};
export var makeInitGivePointsPopupXHRCall = function () {
    return makeXHRCall({
        endpoint: SimpleXHREndpoint.GIVE_POINTS_POPUP,
        method: SimpleXHRMethod.GET,
    });
};
export var makeXHRCall = createAction(actionTypePrefix + "/MAKE_XHR_CALL", function (payload) { return payload; });
export var setIsLoading = createAction(actionTypePrefix + "/SET_IS_LOADING", function (payload) { return payload; });
export var storeResult = createAction(actionTypePrefix + "/STORE_RESULT", function (payload) { return payload; });
//# sourceMappingURL=actionCreators.js.map